// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import {
  NewQuoteProductCurrentPriceStep,
  type QuoteProductCurrentPriceStep,
  type QuoteProductCurrentPriceStepWireFormat,
} from '../QuoteProductCurrentPriceStep/QuoteProductCurrentPriceStep';

export class QuoteProductCurrentPrice {
  readonly price: Currency;
  readonly steps: QuoteProductCurrentPriceStep[];

  constructor(data: { [key: string]: any } = {}) {
    this.price = NewCurrency(data.price);
    this.steps = (data.steps ?? []).map((steps: any) => NewQuoteProductCurrentPriceStep(steps));
  }

  static zero(): QuoteProductCurrentPrice {
    const zeroValues: ExcludeMethodsDeep<QuoteProductCurrentPrice> = {
      price: Currency.zero(),
      steps: [],
    };
    return new QuoteProductCurrentPrice(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteProductCurrentPriceWireFormat = {
  price: CurrencyWireFormat;
  steps: QuoteProductCurrentPriceStepWireFormat[];
};

type NewQuoteProductCurrentPriceProps = PartialDeep<
  QuoteProductCurrentPrice,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductCurrentPrice: (
  props: NewQuoteProductCurrentPriceProps,
) => QuoteProductCurrentPrice = (props) => new QuoteProductCurrentPrice(props);

type NewQuoteProductCurrentPriceFromWireFormatProps = PartialDeep<
  QuoteProductCurrentPriceWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductCurrentPriceFromWireFormat: (
  props: NewQuoteProductCurrentPriceFromWireFormatProps,
) => QuoteProductCurrentPrice = (props) => new QuoteProductCurrentPrice(props);
